<template>
  <div class="index-container">
    <div class="main-top">
      <div class="main-logo"></div>
      <div class="main-menu">
        <div class="menu-control">
          <ul id="menu"><DynamicMenu></DynamicMenu></ul>
        </div>
      </div>
      <div class="main-top-right">
        <div class="menu-control">
          <ul id="menu2">
            <ejs-menu :items="userItems" :select='userItem'></ejs-menu>
          </ul>
        </div>
        <button class="e-control e-lib e-btn exit-btn" data-ripple="true" type="button" @click="exit">
          <span class="icon hero-icon hero-icon-out"></span>{{$t('Index.exit')}}
        </button>
      </div>
    </div>
    <router-view></router-view>
    <CustomDialog ref="pwdDialog"
        v-bind:element="pwdDialog.element"
        v-bind:styles="pwdDialog.styles">
      <template slot="dialog-content">
        <ModifyPasswd ref="modiyPwd"></ModifyPasswd>
      </template>
    </CustomDialog>
    <CustomDialog ref="versionDialog"
        v-bind:element="versionDialog.element"
        v-bind:styles="versionDialog.styles">
      <template slot="dialog-content">
        <div>{{version}}</div>
      </template>
    </CustomDialog>
    <ejs-toast ref='toastInfo' id='accountToast' :position='toastInfo.position' :newestOnTop="onTop" showCloseButton=true
               :animation="toastInfo.showAnimation"></ejs-toast>
  </div>
</template>
<script>
import DynamicMenu from '../../components/frame/DynamicMenu';
import CustomDialog from '../../components/common/CustomDialog';
import ModifyPasswd from '../../components/security/accountManager/modifyPasswd'
import { EventBus } from '../../plugins/eventBus'

export default {
  name: 'Index',
  components: {
    DynamicMenu,
    CustomDialog,
    ModifyPasswd
  },
  data() {
    return {
      onTop: false,
      userItems: [
        {
          text: '',
          iconCss: 'icon hero-icon hero-icon-user',
          items: [
            {
              text: `${this.$t('Login.updPasswdTitle')}`,
              code: 'updpwd'

            },
            {
              separator: true
            },
            {
              text:  `${this.$t('Index.help')}`,
              code: 'help'
            },
            {
              separator: true
            },
            {
              text:  `${this.$t('Index.about')}`,
              code: 'about'
            }
          ]
        }
      ],
      versionDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'upLicDialog',
          buttonGroup: [
            {
              click: this.closeVersionDialog,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Index.version')}`
        },
        styles: {
          width: '350px',
          height: '200px',
          model: true,
          visible: false
        }
      },
      pwdDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'pwdDialog',
          buttonGroup: [
            {
              click: this.closeModify,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.modifyPwd,
              buttonModel: { cssClass: 'e-primary', content: `${this.$t('Common.ok')}` }
            }
          ],
          title: `${this.$t('Login.updPasswdTitle')}`
        },
        styles: {
          width: '600px',
          height: '400px',
          model: true,
          visible: false
        }
      },
      toastInfo: {
        position: {
          X: 'Right', Y: 'Bottom'
        },
        showAnimation: { show : { effect: 'SlideBottomIn' }, hide : { effect: 'SlideBottomOut'} }
      },
      version: '',
      updPwdAccountId: ''
    };
  },
  mounted() {
	  this.$axios.get('/lte/security/findmldnId', {}).then(res => {
	    localStorage.setItem('mldn-session-id', res.data)
    });
    let userUrl = '/lte/ems/strategy/findAccountStrategy';
    let pwdUrl = '/lte/ems/strategy/findPwdStrategy';
    let verUrl = '/lte/security/findVersion';
    this.axios.get(userUrl, {}).then(response => {
      const result = response.data;
      sessionStorage.setItem('userStrategy', JSON.stringify(result.items));
    });
    this.axios.get(pwdUrl, {}).then(response => {
      const result = response.data;
      sessionStorage.setItem('pwdStrategy', JSON.stringify(result.items));
    });
    this.axios.get(verUrl, {}).then(response => {
      const result = response.data;
      sessionStorage.setItem('version', result);
    });
    this.$axios.get('/lte/security/findSecuritySubject', {}).then((res) => {
      if(res.status==200) {
        if (!!res.data) {
          let user =res.data;
          this.findRemind(user.username);
          let item = this.userItems[0];
          item.text = user.username;
          this.$set(this.userItems, 0, item);
        } else {
          window.location.url = '/login'
        }
      }
    });
    EventBus.$on('toast', ({type, content}) => {
      this.showToast(type, content);
    })
  },
  methods: {
    findRemind(username) {
      let That = this;
      this.$axios.get('/lte/ems/user/findRemind', {
        params: {
          username: username
        }
      }).then(response => {
        if (response.data) {
          let reminds = response.data;
          if (reminds!=null && reminds.length > 0) {
            reminds.forEach((mind) => {
              That.showToast('info', mind.content);
            })
          }
        }
      })
    },
    // 拓扑全屏隐藏菜单栏
    menuControl(flag) {
      if (flag) {
        document.getElementsByClassName('main-top')[0].setAttribute('style', 'display: none;');
      } else {
        document.getElementsByClassName('main-top')[0].setAttribute('style', 'display: block;');
      }
    },
    userItem(args) {
      let code = args.item.code;
      if (code == 'updpwd') {
        // 显示密码修改窗口
        this.$refs.pwdDialog.show();
        this.$refs.modiyPwd.initStrategy();
      }else if (code == 'about') {
        // 显示版本号窗口
        this.displayVersionDialog();
      }else if (code == 'help') {
        // 获取语言
        let locale = localStorage.getItem('locale');
        let url = '/help/en/index.html';
        if (locale == 'zh') {
          url = '/help/zh/index.html';
        }
        window.open(url, '_blank')
      }
    },
    modifyPwd() {
      let userId = '';
      if(this.updPwdAccountId != '') {
        userId = this.updPwdAccountId;
      }
      const modify_url = '/lte/ems/user/modifyPwd';
      let validate = this.$refs.modiyPwd.validate();
      if(validate) {
        const password = this.$refs.modiyPwd.getModifyParams();
        const That = this;
        this.$axios.post(modify_url, {
          password: password,
          userId: userId
        }).then(response => {
          That.updPwdAccountId = '';
          That.closeModify();
          if (response.data == 1) {
            That.showToast('success', `${That.$t('Common.tips.success')}`);
          } else if(response.data == 3) {
            let pwdStrategy = JSON.parse(sessionStorage.getItem('pwdStrategy'));
            That.showToast('error', `${That.$t('Index.pwdFreq')}`.replace('{0}', pwdStrategy['pwd.updMinTime']));
          } else {
            That.showToast('error', `${That.$t('Common.tips.failure')}`);
          }
        })
      }
    },
    closeModify() {
      this.$refs.pwdDialog.clear();
      this.$refs.pwdDialog.close();
    },
    displayVersionDialog() {
      let systemVersion = sessionStorage.getItem("version");
      this.version = systemVersion.replace(/"/g, '');
      this.$refs.versionDialog.show();
    },
    closeVersionDialog() {
      this.$refs.versionDialog.close();
    },
    exit() {
      let That = this;
      this.$axios.get('/lte/security/logout', {}).then((res) => {
        if (res.data == 1) {
          localStorage.removeItem('mldn-session-id')
          That.$router.replace({
            path: '/login'
          });
        }else {
          That.showToast('error', `${That.$t('Login.failure')}`);
        }
      })
    },
    showToast(type, content) {
      let types = ['info', 'success', 'warning', 'error'];
      let classArr = ['e-toast-info', 'e-toast-success', 'e-toast-warning', 'e-toast-danger'];
      let iconArr = ['e-info toast-icons', 'e-success toast-icons', 'e-warning toast-icons', 'e-error toast-icons'];
      let titleArr = [`${this.$t('Common.information')}`, `${this.$t('Common.success')}`, `${this.$t('Common.warning')}`, `${this.$t('Common.error')}`];
      let index = 0;
      types.forEach((t, i) => {
        if(t==type) {
          index = i;
        }
      });
      this.$refs.toastInfo.show({
        title: titleArr[index],
        content: content,
        cssClass: classArr[index],
        icon: iconArr[index]
      })
    }
  }
};
</script>
<style>
@import '../../styles/index.css';

.index-container{
  width: 100vm;
  height: 100vh;
  overflow: hidden;
}
</style>
